<template>
  <hm-container :showHeader="false">
    <div class="alert">
      此工具生成的超链接只能用于手机端浏览器打开，可以将生成的链接用于短信或邮件发送，可以通过链接打开微信并跳转到指定的小程序页面
    </div>
    <el-form label-width="100px">
      <el-form-item label="小程序名称">
        {{ currentMp.nickName }}
      </el-form-item>
      <el-form-item label="小程序">
        <el-input
          size="small"
          v-model="mpHref"
          placeholder="请输入小程序链接"
        ></el-input>
        <div>
          <a
            style="color: #2d8cf0"
            href="https://www.yuque.com/docs/share/a7c5b753-d36e-471e-825e-9b73523f6f7e"
            target="_blank"
            >请确保小程序页面路径可以被访问，获取更多页面路径</a
          >
        </div>
      </el-form-item>
      <div class="btn-wrapper">
        <el-button
          :disabled="!mpHref || !currentMp.nickName"
          @click="generateShortUrl"
          type="primary"
          size="small"
          >确认生成链接</el-button
        >
      </div>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div>
        <p class="paragraph">
          页面仅显示一次，请确认已经复制或保存当前生成的链接
        </p>
        <p class="paragraph">
          请复制链接并在<strong class="strong">手机端浏览器</strong>中打开：
        </p>
        <div>
          {{ shortUrl }}
          <input
            class="copy-ipt"
            type="text"
            :value="shortUrl"
            ref="activityListUrl"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="copyUrl" type="primary" size="small"
          >复制链接</el-button
        >
        <el-button size="small" @click="dialogVisible = false"
          >已经保存链接，可以关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-container>
</template>

<script>
import { getLoginUser } from "@/utils/auth";

export default {
  data() {
    return {
      currentMp: {},
      dialogVisible: false,
      mpHref: "",
      shortUrl: ""
    };
  },
  created() {
    this.queryBindMpList();
  },
  mounted() {},
  methods: {
    async queryBindMpList() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch("queryBindMpList");
      this.mpList = result;
      this.currentMp = result.find(v => v.storeCode === storeCode);
    },
    async createShortUrl() {
      const { result } = await this.$store.dispatch("createUrlSchema", {
        _expire: false,
        authorizerAppid: this.currentMp.authorizerAppid,
        jump_wxa: {
          path: this.mpHref.split("?")[0],
          query: this.mpHref.split("?")[1]
        }
      });
      const { openlink } = result;
      const href = encodeURIComponent(
        `https://www.hemiao100.com/linkToMp?href=${openlink}`
      );
      let data = await this.$store.dispatch("longUrlToShort", href);
      this.shortUrl = data.result;
      this.dialogVisible = true;
    },
    async generateShortUrl() {
      const { result } = await this.$store.dispatch("generateShortUrl", {
        page: this.mpHref
      });
      this.shortUrl = result;
      this.dialogVisible = true;
    },
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        type: "success",
        message: "复制成功"
      });
    }
  }
};
</script>

<style scoped lang="scss">
.alert {
  background: #fdf6ec;
  color: #e6a23c;
  padding: 20px;
  margin-bottom: 40px;
}

.paragraph {
  margin-bottom: 20px;
  color: #d9001b;
  .strong {
    font-size: 18px;
  }
}

.copy-ipt {
  position: fixed;
  left: -100vw;
}
</style>
